<script>
import DataProvider from './DataProvider.vue';
import DepartmentRepository from '../../js/repository/DepartmentRepository';

export default {
    components: {
        'kgr-data-provider': DataProvider,
    },
    props: {
        departmentId: {
            type: Number,
            required: true,
        },
        callback: {
            type: Function,
            required: false,
        }
    },
    render(createElement) {
        return createElement(DataProvider, {
            props: {
                repository: DepartmentRepository.findEmployees,
                params: [this.departmentId],
                callback: this.callback,
            },
            scopedSlots: this.$scopedSlots,
        });
    }
}
</script>
